import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { DaylightContext } from '../DaylightCodeMapper';
import moment from 'moment';

const DownloadCodeExportButton = () => {
    const dispatch = useDispatch();
    // TODO: make sure this is working
    const { practiceName, practiceId, partnerId } = useContext(DaylightContext);
    const isLoadingCodes = useSelector(
        (state) => state.daylight.isLoadingCodes
    );
    const [downloadingExport, setDownloadingExport] = useState(false);
    const downloadCodesExport = () => {
        setDownloadingExport(true);
        dispatch(
            actions.daylight.exportDaylightCodes(
                practiceId,
                partnerId,
                `Daylight-${practiceName}-Codes-${moment().format(
                    'YYYY-MM-DD'
                )}.csv`.replace(' ', '')
            )
        ).then((res) => setDownloadingExport(false));
    };
    return (
        <Button
            color="success"
            onClick={downloadCodesExport}
            disabled={downloadingExport || isLoadingCodes}>
            {downloadingExport ? 'Exporting...' : 'Export All'}&emsp;
            <FontAwesomeIcon icon={faFileDownload} />
        </Button>
    );
};

export default DownloadCodeExportButton;
